import { apiPost } from '../api'

export const save_event = data => {
  return apiPost({
    endpoint: 'events/save_event',
    data: data
  })
}
